<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
    </div>
    <!-- Logo -->
    <div class="logo">
      <img class="logo-img" :src="logoImg" alt="" />
    </div>
    <div class="logo-title">玄机AI推广大使系统</div>
    <div class="phone-item">
      <img class="user-img" :src="userImage" alt="" />
      <el-input
        class="phone-input"
        placeholder="用户名"
        v-model="loginForm.account"
        @focus="focusUsername"
        clearable
      >
      </el-input>
    </div>
    <div class="phone-item">
      <img class="mima-img" :src="mimaImage" alt="" />
      <el-input
        class="phone-input"
        placeholder="请输入密码"
        v-model="loginForm.password"
        @focus="focusPassword"
        show-password
      >
      </el-input>
    </div>
    <!-- 自动登录 -->
    <div class="auto-login">
      <el-checkbox v-model="autoChecked" @change="handleAutoChecked"
        >自动登录</el-checkbox
      >
    </div>
    <div class="login">
      <el-button @click="handleLogin">登录</el-button>
    </div>
    <!-- footer -->
    <div class="footer">
      Copyright@ {{ currentYear }} 深圳市玄机人工智能科技有限公司
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>
  </div>
</template>
  
  <script>
import { getMd5 } from "@/utils/md5";
export default {
  name: "LoginPage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      currentYear: "",
      autoChecked: false,
      loginForm: {
        account: "",
        password: "",
      },
      message: "用户名错误",
      show: false,
      drawer: false,
      direction: "btt",
      env: process.env.VUE_APP_BASE_API,
      logoImg: require("@/assets/logo.png"),
      closeImage: require("@/assets/close.png"),
      userImage: require("@/assets/icon-username.png"),
      mimaImage: require("@/assets/icon-mima.png"),
    };
  },
  watch: {

  },
  async mounted () {
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  },
  methods: {
    handleAutoChecked () {
      console.log('this.autoChecked', this.autoChecked);
    },

    handleLogin () {
      if (!this.loginForm.account) {
        this.show = true
        this.message = "用户名错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return;
      }

      if (!this.loginForm.password) {
        // 请输入验证码
        this.show = true
        this.message = "密码错误"
        setTimeout(() => {
          this.show = false
        }, 3000)
        return;
      }
      const params = {
        account: this.loginForm.account,
        password: getMd5(this.loginForm.password),
      };
      this.$store
        .dispatch("user/login", params)
        .then(() => {
          this.$toast('登录成功');
          this.$router.push({
            path: "/home",
          });
        })
        .catch(() => {
          console.log("login-error");
        });
    },
    focusPassword () {
    },
    focusUsername () {
    },
    goBack () {
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding: 0px 16px;
  background: linear-gradient(180deg, #d4e4ff 0%, #f5f5f5 100%);
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.fanyi-img {
  width: 18px;
  height: 18px;
  line-height: 16px;
  float: right;
  margin: 10px 16px 0px 0px;
  cursor: pointer;
  border: 2px solid #201f34;
  font-size: 12px;
}

.title {
  font-family: PingFang SC;
  font-size: 36px;
  font-weight: 600;
  line-height: 54px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 26px 26px 26px 10px;
}

.phone {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding: 0px 24px 0px 8px;
}

.line {
  width: 57px;
  height: 2px;
  /* 2-辅色 */
  background: #201f34;
  margin: 8px auto;
}
.phone-item {
  position: relative;
  margin: 33px 8px 24px 8px;
}
.user-img {
  position: absolute;
  top: 18px;
  left: 20px;
  z-index: 999;
  width: 20px;
  height: 20px;
}
.mima-img {
  position: absolute;
  top: 18px;
  left: 20px;
  z-index: 999;
  width: 20px;
  height: 20px;
}
.phone-img {
  position: absolute;
  top: 14px;
  left: 16px;
  z-index: 999;
  width: 24px;
  height: 24px;
}
.phone-input >>> .el-input__inner {
  border-radius: 8px;
  background: #ffffff;
  height: 54px;
  padding-left: 50px;
  font-size: 16px;
}

.login {
  width: 100%;
}
::v-deep .el-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
}

.pop {
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 99999;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
}
.tip {
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}

.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.drawer-item {
  padding: 0px 16px;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
}
.drawer-content {
  display: flex;
  height: 20px;
  line-height: 20px;
  padding: 14px 16px;
}
.checked-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.item-left {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #201f34;
  padding: 0px 5px;
}
.item-right {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #8e8e8e;
}
.drawer >>> .el-drawer__body {
  padding: 0px 16px;
  margin-top: -10px;
}

.logo {
  width: 85px;
  margin: 24px auto;
}
.logo-img {
  width: 85px;
  height: 85px;
}
.logo-title {
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #0e273b;
}

.login >>> .el-button {
  width: 100%;
  height: 44px;
  background: #0475fd;
  color: #ffffff;
  border-radius: 22px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  margin-top: 30px;
}
.auto-login {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #0e273b;
  text-align: center;
}

::v-deep .el-checkbox__inner {
  border: 1px solid #bfbfc1;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0475fd;
  border: 1px solid #ffffff;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0e273b;
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 37px;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #8d8d8d;
  text-align: center;
  margin: 0 auto;
}
</style>
  